<div class="bg_image">
  <div class="row pt-5">
    <div class="col-12 d-flex justify-content-between align-items-center">
      <img src="assets\img\background\NBR_logo.jpg" class="nbr_logo">
      <img src="assets\img\logo\eReturn_Logo.svg" class="ereturn-logo">
    </div>
  </div>
  <div class="row mt-5 mb-4">
    <div class="col-12 text-center">
      <h5><strong>FAQ- e-Return</strong></h5>
    </div>
  </div>

  <div class="container">
    <div class="row">
      <div class="col-12" style="font-family: Solaiman Lipi !important">
        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">১.</div>
            <div>আমি অনলাইনে রিটার্ন দাখিল করতে চাই। কিভাবে শুরু করব?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 30px"></div>
            <div>উত্তরঃ অনলাইনে রিটার্ন দাখিলের জন্য <strong>e-Return</strong> সিস্টেমে রেজিস্ট্রেশন করতে হবে। উক্ত
              সিস্টেমে রেজিস্ট্রেশনের জন্য আপনার জাতীয় পরিচয়পত্র ব্যবহারপূর্বক বায়োমেট্রিক পদ্ধতিতে নিবন্ধিত সিমকার্ড
              সম্বলিত মোবাইল ফোন নম্বর ও একটি টিআইএন প্রয়োজন। প্রথমবার সফলভাবে রেজিস্ট্রেশন করার পর সাইন-ইন করে
              প্রোফাইলের তথ্য প্রয়োজন অনুসারে আপডেট করতে পারবেন। এরপর ধাপে ধাপে আপনার খাত ভিত্তিক আয়, বিনিয়োগ, পারিবারিক
              ব্যয়, সম্পদ ও দায় এবং কর পরিশোধের তথ্য ইনপুট দিয়ে সহজেই রিটার্ন দাখিল করতে পারবেন। উল্লেখ্য, তথ্য ইনপুট
              দেবার সময় সকল প্রমাণ ও তথ্য দেখে সঠিকভাবে ইনপুট দেওয়া বাঞ্ছনীয়।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">২.</div>
            <div>e-Return সিস্টেমে সাইন-ইন করব কিভাবে?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 20px"></div>
            <div>উত্তরঃ এই সিস্টেমে সাইন-ইন করার জন্য টিআইএন ও পাসওয়ার্ড প্রয়োজন। আপনি <a target="_blank"
                                                                                          href="https://www.etaxnbr.gov.bd">www.etaxnbr.gov.bd</a>
              ওয়েবসাইটে রেজিস্ট্রেশন করার সময় নিজের পাসওয়ার্ড ঠিক করে নিবেন। এরপর যেকোন সময় টিআইএন ও পাসওয়ার্ড ব্যবহার
              করে সাইন-ইন করতে পারবেন। এছাড়া আপনার প্রয়োজনে পাসওয়ার্ড পরিবর্তন করতে পারবেন।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৩.</div>
            <div>e-Return সিস্টেমে রেজিস্ট্রেশনের জন্য কি প্রয়োজন?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 20px"></div>
            <div>উত্তরঃ <strong>e-Return</strong> সিস্টেমে রেজিস্ট্রেশনের জন্য আপনার টিআইএন ও জাতীয় পরিচয়পত্র ব্যাবহার
              পূর্বক বায়োমেট্রিক পদ্ধতিতে নিবন্ধিত সিমকার্ড সম্বলিত মোবাইল ফোন নম্বর প্রয়োজন। আপনার ব্যবহৃত মোবাইল ফোনটি
              আপনার নামে রেজিস্টার্ড কিনা তা যাচাইয়ের জন্য <strong>*১৬০০১#</strong> ডায়াল করুন।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৪.</div>
            <div>e-Return সিস্টেমে রেজিস্ট্রেশনের পদ্ধতি কি?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 20px"></div>
            <div>উত্তরঃ <a target="_blank" href="https://www.etaxnbr.gov.bd">www.etaxnbr.gov.bd</a> ওয়েবসাইটে I am not
              registered yet বাটনে ক্লিক করে পরবর্তীতে আপনার টিআইএন ও মোবাইল ফোন নম্বর ইনপুট দিয়ে <b>“Verify”</b> বাটনে
              ক্লিক
              করলে আপনার মোবাইলে ৬ ডিজিটের একটি ওটিপি যাবে যা টাইপ করে পাসওয়ার্ড সেট করতে হবে এবং <b>“Register”</b>
              বাটনে ক্লিক
              করলে রেজিস্ট্রেশন সম্পন্ন হবে।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৫.</div>
            <div>টিআইএন খোলার সময় যে মোবাইল নম্বর দিয়েছিলাম তা আর নেই, আমি কি e-Return সিস্টেমে রেজিস্ট্রেশন করতে
              পারব?
            </div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 20px"></div>
            <div>উত্তরঃ হ্যাঁ, পারবেন। টিআইএন খোলার সময় যে মোবাইল নম্বর ব্যবহার করেছিলেন তা গুরুত্বপূর্ণ নয়। আপনার জাতীয়
              পরিচয়পত্র ব্যাবহারপূর্বক বায়োমেট্রিক পদ্ধতিতে নিবন্ধিত সিমকার্ড সম্বলিত মোবাইল ফোন নম্বর দিয়ে রেজিস্ট্রেশন
              করা সম্ভব। কোন একটি মোবাইল নম্বর ব্যবহার করে <strong>e-Return</strong> সিস্টেমে রেজিস্ট্রেশন করার পর
              মোবাইল নম্বর পরির্বতনের সুবিধাও রয়েছে।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৬.</div>
            <div>পাসওয়ার্ড কিভাবে সেট করব? পাসওয়ার্ড ভুলে গেলে কিভাবে তা রিসেট করব?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 30px"></div>
            <div>উত্তরঃ পাসওয়ার্ড কমপক্ষে আট character বিশিষ্ট হবে। এর মধ্যে কমপক্ষে একটি করে Upper Case Alphabete,
              Lower Case Alphabete, Numerical Digit (0-9) এবং Special Character (&#64;, #, $, %, *, &, ! ইত্যাদি) থাকতে হবে।
              ল্যাপটপ বা ডেস্কটপ কম্পিউটার ব্যবহার করলে সিস্টেম আপনাকে গাইড করবে। পাসওয়ার্ড ভুলে গেলে ”Forget Password”
              এ ক্লিক করলে আপনার মোবাইলে একটি OTP যাবে এবং আপনি পাসওয়ার্ড রিসেট করতে পারবেন।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৭.</div>
            <div>মোবাইল নম্বর আমার নামে নিবন্ধিত কিনা তা কিভাবে জানতে পারব?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 20px"></div>
            <div>উত্তরঃ আপনার ব্যবহৃত মোবাইল ফোন নম্বরটি আপনার নামে নিবন্ধিত কিনা তা যাচাইয়ের জন্য
              <strong>*১৬০০১#</strong> ডায়াল করে আপনার জাতীয় পরিচয়পত্র নম্বরের সর্বশেষ 4 ডিজিট ইনপুট দিতে হবে। ইনপুট
              দেবার পর ফিরতি মেসেজে মোবাইল ফোন কোম্পানী আপনাকে আপনার জাতীয় পরিচয়পত্র দিয়ে কয়টি মোবাইল ফোন নম্বর নিবন্ধিত
              তা জানিয়ে দিবে।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৮.</div>
            <div>e-Return এর কোন সমস্যার ক্ষেত্রে সহায়তার জন্য কোথায় যোগাযোগ করব?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 30px"></div>
            <div>উত্তরঃ <strong>e-Return</strong> এর কোন সমস্যার ক্ষেত্রে সহায়তার জন্য জাতীয় রাজস্ব বোর্ডের কল সেন্টারে
              যোগাযোগ করতে পারবেন। কল সেন্টারের <strong>০৯৬৪৩ ৭১৭১৭১</strong> নম্বরে ছুটির দিন ব্যতীত সকাল ৯.০০ টা হতে
              বিকাল ৫.০০টা পর্যন্ত ফোনে আয়কর কর্মকর্তারা তাৎক্ষণিক <strong>e-Return</strong> এর যেকোন সমস্যা বা
              জিজ্ঞাসার উত্তর দিয়ে থাকেন। eReturn Support ( <a target="_blank" href="https://ticket.etaxnbr.gov.bd/">https://ticket.etaxnbr.gov.bd/</a>)
                পোর্টালে ইমেইল করে সহায়তা
                চাইতে পারবেন। এছাড়া আয়কর সেবা মাসে প্রতিটি কর অঞ্চল e-Return সংক্রান্ত সহায়তা প্রদান করছে।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৯.</div>
            <div>মোবাইল ফোনে কি e-Return তৈরী করা যাবে?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 10px"></div>
            <div>উত্তরঃ <strong>e-Return</strong> সিস্টেমকে সহজ ও user friendly করার জন্য অনেক feature দেয়া আছে যার
              অনেকগুলো মোবাইল ডিভাইসে পাওয়া যাবে না। তাই ল্যাপটপ বা ডেস্কটপ কম্পিউটারে এই সিস্টেম ব্যবহার করুন।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">১০.</div>
            <div>অনলাইনে রিটার্ন দাখিলের পর সাপোর্টিং কাগজপত্র কোথায় জমা দিব বা কিভাবে attach করব?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 30px"></div>
            <div>উত্তরঃ এই বছরে অনলাইন রিটার্ন দাখিলে কোনো ডকুমেন্টস upload করতে হবে না। আপনি দরকারি কাগজপত্র সাথে নিয়ে
              বসুন এবং প্রয়োজনীয় ফিল্ডগুলোতে নির্ভুলভাবে এন্ট্রি দিন। অনলাইনে রিটার্ন submit করার সাথে সাথে সিস্টেমে
              আপনার অ্যাসেসমেন্ট হয়ে যাবে এবং আপনি <strong>Acknowledgement slip</strong> পেয়ে যাবেন। <strong>Tax
                certificate</strong> (ট্যাক্স সার্টিফিকেট) সাথে সাথে তৈরি হয়ে যাবে। বামপাশের <strong>Tax record</strong>
              মেনুতে ক্লিক করে আপনি যে কোনো সময় <strong>Acknowledgement slip</strong>, <strong>Tax certificate</strong>
              ও রিটার্নের কপি প্রিন্ট করতে পারবেন।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">১১.</div>
            <div>অনলাইনে রিটার্ন দাখিলের পর পুনরায় কি সার্কেলে রিটার্ন বা কোন প্রমাণ দাখিল করতে হবে?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 10px"></div>
            <div>উত্তরঃ অনলাইনে রিটার্ন দাখিল করার পর পুনরায় সার্কেলে রিটার্ন দাখিলের প্রয়োজন নাই। অনলাইনে রিটার্ন দাখিল
              করার সাথে সাথেই আপনার কর নির্ধারণ(এসেসমেন্ট) সম্পন্ন হয়ে যাবে।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">১২.</div>
            <div>আমি রেজিস্ট্রেশন করেছি। সাইন-ইন করার পর কিভাবে রিটার্ন পূরণ শুরু করব?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 30px"></div>
            <div>
              উত্তরঃ রিটার্ন জমা দেওয়ার নীচের পদক্ষেপগুলি অনুসরণ করুনঃ
              <br/>ক। <a target="_blank" href="https://www.etaxnbr.gov.bd">www.etaxnbr.gov.bd</a> এ প্রবেশ করার পর আপনি
              একটি স্ক্রীন দেখতে পাবেন যার বাম দিকে তিনটি মেনু দেখায় – <strong>Home</strong>,
              <strong>Submission</strong> ও <strong>Tax record</strong>
              <br/>খ। সেই স্ক্রীন থেকে Submission মেনুতে ক্লিক করুন। তারপর সিস্টেম আপনাকে আরেকটি স্ক্রীনে নিয়ে
              গিয়ে Assessment Information এবং Heads of Income দেখাবে ।
              <br/>গ। তারপর ধাপে ধাপে এগিয়ে যান এবং সফটওয়্যার আপনাকে গাইড করবে, যেকোন টার্ম বুঝতে যদি কোন অসুবিধা হয়
              অনুগ্রহ করে প্রথমে ইউজার ম্যানুয়াল অনুসরণ করুন। এছাড়াও অনলাইনে অধিকাংশ অপশনের পাশেই প্রশ্নবোধক চিহ্ন “?”
              রয়েছে যার উপরে ক্লিক করলে সেই সংক্রান্ত বিস্তারিত ব্যাখা পাওয়া যাবে এবং তারপরেও যদি তা বোঝা কঠিন হয় তাহলে
              কল সেন্টারে কল দিয়ে বুঝে নিতে পারেন ।

            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">১৩.</div>
            <div>অনলাইনে রিটার্ন জমা দেবার প্রক্রিয়া কি?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 30px"></div>
            <div>
              উত্তরঃ রিটার্ন জমা দেওয়ার ৭টি ধাপ রয়েছে, সেগুলি নিচে দেয়া হল-
              <br/>i) Assessment - প্রথমে আপনাকে কিছু মৌলিক তথ্য দিতে হবে
              <div class="ml-4">ক। <strong>Assessment information</strong>- Assessment year, Income year ইত্যাদি।</div>
              <div class="ml-4">খ। <strong>Heads of Income</strong>- চাকরি হতে আয়, ভাড়া হতে আয়, কৃষি হতে আয়, ব্যবসা বা
                পেশা হতে আয়, মূলধনী লাভ, আর্থিক পরিসম্পদ হতে আয়, অন্যান্য উৎস হতে আয়। এই খাতসমূহের মধ্যে প্রযোজ্যটি
                সিলেক্ট করতে হবে।
              </div>
              <div class="ml-4">গ। পরবর্তী অংশে অন্যান্য আয় যেমন, ফার্ম বা
                ব্যক্তি সংঘ হতে আয়, দেশের বাহির হতে আয়, স্পাউজ বা মাইনর চাইল্ডের আয় থাকলে সেই খাতসমূহের মধ্যে প্রযোজ্যটি
                সিলেক্ট করতে হবে। এছাড়াও যদি আয়কর আইন, ২০২৩ এর প্রথম তফসিল এর অধীন এক বা একাধিক করবর্ষের আয়ের
                স্বপ্রণোদিত প্রদর্শন করতে চাইলে তা সিলেক্ট করে পুরণ করতে হবে।
              </div>
              <div class="ml-4">ঘ। <strong>Additional Information</strong>- আয়ের প্রধান উৎসের অবস্থান এবং প্রযোজ্যতা
                অনুসারে অন্যান্য কিছু মৌলিক তথ্য সিলেক্ট করতে হবে।

              </div>
              <div class="ml-4">ঙ। <strong>IT-10B requirements</strong> সম্পদ সম্পর্কিত তথ্য যেমন মোট সম্পদের পরিমাণ
                ৫০,০০,০০০ অধিক কিনা, মোটর গাড়ি আছে কিনা, গৃহ সম্পত্তির পরিমাণ ইত্যাদি।
              </div>
              ii) <strong>Income</strong> – এই পেজে খাতভিত্তিক আয়ের সমস্ত তথ্য দিতে হবে, যেমন- চাকরি হতে আয়, ভাড়া হতে
              আয়, কৃষি হতে আয়, ব্যাবসা বা পেশা হতে আয়, মূলধনী আয়, আর্থিক পরিসম্পদ হতে আয় এবং অন্যান্য উৎস হতে আয়।
              <br/>iii) <strong>Rebate</strong>- রেয়াতযোগ্য বিনিয়োগ যেমন জীবন বিমা, ডিপিএস, সঞ্চয়পত্র, জিপিএফ, শেয়ারের
              বিনিয়োগ ইত্যাদির তথ্য উল্লেখ করুন।
              <br/>iv) <strong>Expenditure</strong>- আপনার বাৎসরিক ব্যয় সংক্রান্ত তথ্য প্রদান করুন।
              <br/>v) <strong>Asset & liabilities</strong>- সম্পদ এবং দায় সম্পর্কে বিস্তারিত তথ্য। যেমন: ব্যবসার মূলধন,
              অ-কৃষি সম্পত্তি, কৃষি সম্পত্তি, আর্থিক সম্পদ (শেয়ার, ডিবেঞ্চার, সেভিংস সার্টিফিকেট, এফডিআর, ডিপিএস), মোটর
              গাড়ি, সোনা, হীরা, গৃহস্থালীর জিনিসপত্র, ব্যাংক স্থিতি, নগদ ইত্যাদি। এছাড়া ঋণের তথ্যও প্রদান করুন।
              <br/>vi) <strong>Tax & payment</strong>- এই সেকশনে সিস্টেম আপনাকে আপনার মোট আয়ের বিবরণ, ট্যাক্স
              কম্পিউটেশনের বিবরণ, প্রদেয় করের পরিমাণ দেখাবে । এই সেকশন থেকে আপনি ইতোমধ্যে উৎসে কর্তিত কর, অগ্রিম প্রদত্ত
              কর, পূর্ববর্তী বছরে পরিশোধিত অতিরিক্ত কর এবং রিটার্নের সাথে পরিশোধিত করের তথ্য প্রদান করে আপনার কর
              পরিশোধের তথ্য আপডেট করতে পারবেন। এরপর অনলাইনে রিটার্ন জমা দিতে পারবেন। এই সেকশন হতে আপনি আপনার জন্য
              প্রযোজ্য প্রদেয় কর মোবাইল ব্যাংকিং যেমন- বিকাশ, রকেট, নগদ ইত্যাদি বা ইন্টারনেট ব্যাংকিং ও ডেবিট এবং
              ক্রেডিট কার্ডের মাধ্যমে পরিশোধ করতে পারবেন।
              <br/>vii) <strong>Return view</strong>- এখানে সম্পূর্ণ রিটার্ন দেখাবে, আপনি ভুল কোন তথ্য এন্ট্রি দিয়েছেন
              কিনা তা পরীক্ষা করতে পারবেন, সেভ করে রাখতে পারবেন এবং সবশেষে সাবমিট করতে পারবেন।অনলাইন রিটার্ন পূরণে আপনি
              চাইলে সব তথ্য একেবারে ইনপুট দিয়ে রিটার্ন দাখিল করতে পারেন আবার প্রয়োজনে সময়ে সময়ে তথ্য ইনপুট দিয়ে সেভ করে
              রাখতে পারবেন এবং সময় নিয়ে পরীক্ষা নিরীক্ষা করে সাবমিট করতে পারবেন। সাবমিট করা হলে যেকোনো সময়ে প্রাপ্তি
              স্বীকারপত্র, রিটার্ন, সার্টিফিকেট, চালান ডাউনলোড ও প্রিন্ট করতে পারবেন।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">১৪.</div>
            <div>আমার উৎসে কর ও অগ্রিম কর প্রদান করা আছে। আমি কি অনলাইনে রিটার্ন দাখিল করতে পারব?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 20px"></div>
            <div>উত্তরঃ হ্যাঁ, পারবেন। <strong>Tax & Payment</strong> সেকশনে আপনি ইতোমধ্যে উৎসে কর্তিত কর, অগ্রিম
              প্রদত্ত কর, পূর্ববর্তী বছরে পরিশোধিত অতিরিক্ত কর এবং রিটার্নের সাথে পরিশোধিত করের তথ্য প্রদান করে আপনার কর
              পরিশোধের তথ্য আপডেট করে রির্টান দাখিল করতে পারবেন।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">১৫.</div>
            <div>কর্তিত উৎসে কর ও অগ্রিম করের ক্রেডিট কিভাবে পাব?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 30px"></div>
            <div>উত্তরঃ <strong>Tax & Payment</strong> সেকশনে Total Amount Payable এর নিচে Update Tax Payment Status
              বাটনে ক্লিক করলে <strong>e-Return Ledger</strong> এর হোম পেজ আসবে। এখানে যে নির্দেশনা দেওয়া আছে তা অনুসরণ
              করে বাম পাশের মেনু হতে আপনি উৎসে কর, অগ্রিমকরসহ সকল ধরনের কর পরিশোধের বিবরণ হালনাগাদ করতে পারবেন। উৎসে
              করের ক্ষেত্রে Claim source tax, অগ্রিম করের ক্ষেত্রে Claim AIT, রিটার্নের সাথে পরিশোধিত করের ক্ষেত্রে Tax
              paid with return(173), পূর্ববর্তী বছরের অতিরিক্ত পরিশোধিত কর সমন্বয়ের ক্ষেত্রে Adjustment of tax return
              অপশনে গিয়ে তথ্য হালনাগাদ করতে হবে।
              <br><br>
              Claim Source Tax এর অধীন অন্যান্য উৎসে কর কর্তনের ক্ষেত্রে “other” বাটনে ক্লিক করে প্রথমে Purpose of
              payment হতে উৎসে কর কর্তনের খাত সিলেক্ট করতে হবে। যে কর্তৃপক্ষ উৎসে কর কর্তন করে জমা প্রদান করেছে তার নাম,
              উৎসে করের চালান নম্বর, তারিখ, ব্যাংকের নাম, শাখার নাম পূরণ করতে হবে। তবে কোন ক্ষেত্রে চালানের পরিবর্তে
              সার্টিফিকেট বা প্রত্যয়ন থাকলে সার্টিফিকেটের রেফারেন্স/নথি/স্মারক নম্বর ও তারিখ পূরণ করতে হবে। এরপর উক্ত
              চালান/সার্টিফিকেটের মোট অংক Challan/Certificate amount এ এবং আপনার নিজের জন্য প্রযোজ্য/কর্তিত অংক Claimed
              amount এ টাইপ করতে হবে। উল্লেখ্য, চালান বা সার্টিফিকেটটি শুধুমাত্র আপনার জন্য প্রযোজ্য হলে Challan/
              Certificate amount ও Claimed amount এক হবে। কিন্তু একাধিক ব্যক্তির জন্য হলে Challan/ Certificate amount এ
              সম্পূর্ণ অংক এবং Claimed amount এ নিজের জন্য প্রযোজ্য/কর্তিত উৎসে করের তথ্য ইনপুট দিতে হবে।
              <br/><br/>অগ্রিম কর চালানে পরিশোধের ক্ষেত্রে <strong>AIT (154)</strong> হতে চালানের তথ্য এবং গাড়ির অগ্রিম
              করের ক্ষেত্রে <strong>AIT on Car</strong> হতে ব্যাংক স্লিপের উপরের দিকে ডানে ট্র্যানজাকশন আইডি
              (Transaction No) পূরণ করে কর পরিশোধের তথ্য হালনাগাদ করতে হবে।
              <br/><br/><strong>e-Return Ledger</strong> অংশের জন্য প্রয়োজনীয় ডকুমেন্ট হাতে নিয়ে সতর্কতার সাথে পূরণ
              করতে হবে। অন্যথায় রিটার্ন পূরণ অসত্য ও অসম্পূর্ণ হয়ে যাবে।
              <br/><br/>সর্বশেষ মূল রিটার্নে ফেরত আসতে <strong>e-Return Ledger</strong> এর বামে নিচের <strong>Go to
                Return</strong> বাটনে ক্লিক করতে হবে।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">১৬.</div>
            <div>বেতন হতে উৎসে করের ক্রেডিট কিভাবে পাব?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 30px"></div>
            <div>
              উত্তরঃ <strong>Tax & Payment</strong> সেকশনে Total Amount Payable এর নিচে Update Tax Payment Status বাটনে
              ক্লিক করলে <strong>e-Return Ledger</strong> এর হোম পেজ আসবে। এখানে Claim source tax এ সরকারি কর্মচারি
              যাদের ibas হতে বেতন হয় তারা Salary (ibas) সিলেক্ট করে Search বাটনে ক্লিক করে কর্তিত করের পরিমাণ দেখাবে এবং
              আপনি করের পরিমাণ টাইপ করে সেভ অপশনে ক্লিক করে তথ্য হালনাগাদ করবেন।
              <br/><br/>অন্যান্যদের ক্ষেত্রে <strong>Salary(others)</strong> এ ঢুকে “+Add” বাটনে ক্লিক করে যে কর্তৃপক্ষ
              উৎসে কর কর্তন করে জমা প্রদান করেছে তার নাম, চালান/সার্টিফিকেট এর ধরন সিলেক্ট করে চালান/সার্টিফিকেট এর
              নম্বর, তারিখ পূরণ করতে হবে। এরপর উক্ত চালান/সার্টিফিকেটের মোট অংক Challan/Certificate amount ঘরে এবং আপনার
              নিজের জন্য প্রযোজ্য/কর্তিত অংক Claimed amount ঘরে টাইপ করতে হবে। উল্লেখ্য চালান বা সার্টিফিকেটটি শুধুমাত্র
              আপনার জন্য প্রযোজ্য হলে Challan/Certificate amount ও Claimed amount এক হবে। কিন্তু একাধিক ব্যক্তির জন্য
              হলে Challan/Certificate amount এ সম্পূর্ণ অংক এবং Claimed amount এ নিজের জন্য প্রযোজ্য/কর্তিত উৎসে করের
              তথ্য ইনপুট দিতে হবে।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">১৭.</div>
            <div>ব্যাংক, সঞ্চয়পত্র ও ডিভিডেন্ড এর উৎসে করের ক্রেডিট কিভাবে দাবী করব?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 30px"></div>
            <div>উত্তরঃ <strong>Tax & Payment</strong> সেকশনে Total Amount Payable এর নিচে Update Tax Payment Status
              বাটনে ক্লিক করলে <strong>e-Return Ledger</strong> এর হোম পেজ আসবে। এখানে <strong>Claim source tax</strong>
              এ <strong>Sanchaypatra/BankFI Interest/Other (Dividend-Section-117)</strong> হতে Sync from Income সিলেক্ট
              করে পরের স্ক্রীনে প্রয়োজনীয় তথ্য ইনপুট দিয়ে Save বাটনে ক্লিক করে কর্তিত করের পরিমাণ হালনাগাদ করতে হবে।
              এক্ষেত্রে <strong>e-Return Ledger</strong> এ প্রবেশের পূর্বে সংশ্লিষ্ট খাতের আয়ের তথ্য পূরণ না করলে Sync
              from Income ক্লিক করলে কোন তথ্য আসবে না।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">১৮.</div>
            <div>মিটিং ফি, ট্রেনিং ফি, সম্মানী হতে প্রাপ্ত আয় কোন ধরনের আয় হিসেবে প্রদর্শন করব?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 20px"></div>
            <div>উত্তরঃ মিটিং ফি, ট্রেনিং ফি, সম্মানী হতে প্রাপ্ত আয় হতে উৎসে কর কর্তন করা থাকলে <strong>Income from
              other source</strong> এর Income type এ <strong>Other source (with TDS)</strong> সিলেক্ট করে আয়ের তথ্য পূরণ
              করতে হবে। যদি উৎসে কর কর্তন করা না থাকে তবে Income type এ Any other income সিলেক্ট করে আয়ের তথ্য পূরণ করতে
              হবে।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">১৯.</div>
            <div>৩০/০৬/২০১৯ তারিখের পূর্বের সঞ্চয়পত্রের উৎসে করের ক্রেডিট কিভাবে পাব?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 30px"></div>
            <div>উত্তরঃ <strong>Tax & Payment</strong> সেকশনে Total Amount Payable এর নিচে Update Tax Payment Status
              বাটনে ক্লিক করলে e-Return Ledger এর হোম পেজ আসবে। এখানে Claim source tax এ Sanchaypatra হতে Sync from
              Income সিলেকপূর্বে সংশ্লিষ্টরীনে Income page এ Financial asset>Sanchaypatra আয়ের সকল তথ্য প্রদর্শন করবে।
              এরপর প্রয়োজনীয় তথ্য ইনপুট দিয়ে Save বাটনে ক্লিক করে কর্তিত করের পরিমাণ হালনাগাদ করতে হবে। এক্ষেত্রে
              <strong>e-Return Ledger</strong> এ প্রবেশের পূর্বে সংশ্লিষ্ট খাতের আয়ের তথ্য পূরণ না করলে Sync from Income
              ক্লিক করলে কোন তথ্য আসবে না।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">২০.</div>
            <div>যৌথ সঞ্চয়পত্রের মুনাফা ও উৎসে করের তথ্য কিভাবে প্রদর্শন করব?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 30px"></div>
            <div>উত্তরঃ <strong>Tax & Payment</strong> সেকশনে Total Amount Payable এর নিচে Update Tax Payment Status
              বাটনে ক্লিক করলে <strong>e-Return Ledger</strong> এর হোম পেজ আসবে। এখানে Claim source tax এ Sanchaypatra
              হতে Sync from Income সিলেক্ট করলে পরের স্ক্রীনে Income page এ Financial asset>Sanchaypatra এ পূরণকৃত আয়ের
              সকল তথ্য প্রদর্শন করবে। এখানে TDS available এর মধ্যে নিজের অংশের জন্য প্রযোজ্য অংক TDS claim (in case of
              joint holder your portion only) এ পূরণ করতে হবে।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">২১.</div>
            <div>গাড়ির অগ্রিম করের ক্রেডিট কিভাবে দাবী করব?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 30px"></div>
            <div>উত্তরঃ <strong>Tax & Payment</strong> সেকশনে Total Amount Payable এর নিচে Update Tax Payment Status
              বাটনে ক্লিক করলে <strong> e-Return Ledger </strong> এর হোম পেজ আসবে। এখানে Claim AIT হতে AIT on Car এ
              Unique Key (Transaction No.) টাইপ করার পর Search করে Save করতে হবে।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">২২.</div>
            <div>e-Return সিস্টেমের মাধ্যমে কর পরিশোধ করা যায় কি?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 30px"></div>
            <div>উত্তরঃ প্রযোজ্য কর অপরিশোধিত থাকলে <strong>Tax & Payment</strong> সেকশন এর নিচে অপরিশোধিত কর Payable এ
              প্রদর্শন করবে এবং Pay Now বাটন একটিভ থাকবে। Pay Now বাটন ক্লিক করে আপনি আপনার জন্য প্রযোজ্য অপরিশোধিত কর
              এ-চালান বা সোনালী ব্যাংক গেটওয়ে ব্যবহার করে মোবাইল ব্যাংকিং যেমন- বিকাশ, রকেট, নগদ ইত্যাদি বা ইন্টারনেট
              ব্যাংকিং এবং ডেবিট ও ক্রেডিট কার্ডের মাধ্যমে কর পরিশোধ করতে পারবেন।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">২৩.</div>
            <div>পূর্ববর্তী বছরের অতিরিক্ত পরিশোধিত কর কিভাবে প্রদর্শন করব?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 30px"></div>
            <div>উত্তরঃ <strong>Tax & Payment</strong> সেকশনে Total Amount Payable এর নিচে Update Tax Payment Status
              বাটনে ক্লিক করলে <strong>e-Return Ledger</strong> এর হোম পেজ আসবে। এখানে বামপাশের Adjustment of tax refund
              মেনু হতে আপনি পূর্ববর্তী বছরের অতিরিক্ত পরিশোধিত করের সমন্বয় প্রদর্শন করতে পারবেন। তবে উপ কর কমিশনার আপনার
              প্রদর্শন সঠিক কিনা তা পরবর্তীতে চেক করার পর এ সমন্বয় সম্পূর্ণরুপে কার্যকর হবে।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">২৪.</div>
            <div>আমি একজন মহিলা, কিন্তু পুরুষ হিসেবে আমার কর পরিগণনা হচ্ছে। এর কারণ কি এবং করণীয় কি?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 20px"></div>
            <div>উত্তরঃ টিআইএন রেজিস্ট্রেশনের সময় আপনার Gender ভুলবশত Male সিলেক্ট হওয়ায় এই সমস্যা হচ্ছে। আপনি টিআইএন
              সিস্টেমে Edit/Correct/Update অপশন হতে এটি পরিবর্তন করে <strong>e-Return</strong> সিস্টেমে Profile হতে Sync
              with TIN option এ ক্লিক করে আপডেট করতে পারবেন। প্রয়োজনে কল সেন্টারের সহায়তা গ্রহণ করুন।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">২৫.</div>
            <div>e-Return এ আয়কর রিটার্ন জমা প্রদানের সুবিধা কি?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 10px"></div>
            <div>উত্তরঃ e-Return সিস্টেমে রিটার্ন জমা দেওয়া হলে নিম্নোক্ত সুবিধা পাবেনঃ
              <br/>i) ঘরে বসে আয়কর রিটার্ন দাখিল করতে পারবেন।আয়কর অফিসে যাওয়ার প্রয়োজন হবে না।
              <br/>ii) টিন সার্টিফিকেট প্রিন্ট/ডাউনলোড করতে পারবেন।
              <br/>iii) রিটার্ন ও ট্যাক্স সার্টিফিকেট প্রিন্ট/ডাউনলোড করতে পারবেন।
              <br/>iv) রিটার্ন জমা দেওয়ার প্রমাণ হিসেবে <strong>Acknowledgement slip</strong> ডাউনলোড করতে পারবেন।
              <br/>v) এই সিস্টেমের মাধ্যমে পরিশোধিত করের চালান ডাউনলোড ও প্রিন্ট করতে পারবেন।
              <br/>vi) এই সিস্টেমের মাধ্যমে পূর্ববর্তী বছরসমূহে কোন রিটার্ন দাখিল করা হয়ে থাকলে তার রেকর্ড প্রিন্ট এর
              সুবিধা পাওয়া যাবে।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">২৬.</div>
            <div>{{ currentAssessmentYear | convertNumWithOtherCharsToBn }} কর বছরে কার জন্য <strong>e-Return</strong>
              দাখিল বাধ্যতামূলক?
            </div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 20px"></div>
            <div>উত্তরঃ {{ currentAssessmentYear | convertNumWithOtherCharsToBn }} কর বছরে সকল স্বাভাবিক ব্যক্তি করদাতার
              জন্য অনলাইন রিটার্ন দাখিল বাধ্যতামূলক। তবে নিম্নলিখিত ব্যক্তিবর্গ এই শর্তের আওতামুক্ত থাকবে-
              <br/>ক) ৬৫ বছর বা তদূর্ধ্ব বয়সের প্রবীণ করদাতা
              <br/>খ) শারীরিকভাবে অসমর্থ বা বিশেষ চাহিদাসম্পন্ন করদাতা
              <br/>গ) বিদেশে অবস্থানরত বাংলাদেশী করদাতা
              <br/>ঘ) মৃত করদাতার পক্ষে আইনগত প্রতিনিধি।
              <br/><br/>তবে উপরে বর্ণিত করদাতাগণ ইচ্ছাপোষণ করলে অনলাইন রিটার্ন দাখিল করতে পারবেন। এছাড়া, ই-রিটার্ন
              সিস্টেমে নিবন্ধন সংক্রান্ত সমস্যার কারণে অনলাইনে রিটার্ন দাখিলে সমর্থ না হলে সংশ্লিষ্ট উপ কর কমিশনারের
              নিকট যৌক্তিক কারণসহ আবেদন করলে সংশ্লিষ্ট অতিরিক্ত/যুগ্ম কর কমিশনারের অনুমোদনক্রমে পেপার রিটার্ন দাখিল করতে
              পারবেন।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">২৭.</div>
            <div>গতবছর অনলাইনে রিটার্ন দাখিলের সময় সম্পদ বিবরণীতে সম্পদের তথ্য পূরণ করেছি, এবারও কি পূরণ করতে হবে?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px"></div>
            <div>উত্তরঃ না, আপনি সম্পদ-দায় অংশে <strong>অটো ফিল (Autofill)</strong> অপশনে ক্লিক করলেই পূর্ববর্তী বছরের
              তথ্য চলে আসবে, এখন প্রয়োজন মাফিক আপনি এডিট, ডিলিট, এ্যড, আপডেট করতে পারবেন।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">২৮.</div>
            <div>গতবার আমি অনলাইনে রিটার্ন তৈরী করে প্রিন্ট কপি অফিসে জমা দিয়েছি। কিন্ত এবার <strong>e-Return</strong> এ
              সেই তথ্য পাচ্ছি না। করণীয় কি?
            </div>
          </div>
          <div style="display:flex">
            <div style="width:40px"></div>
            <div>উত্তরঃ বিগত বছর আপনি <strong>e-Return</strong> সিস্টেমে রিটার্ন তৈরী করলেও অনলাইনে তা দাখিল করেননি। তাই
              সিস্টেম আপনার তথ্য সংরক্ষণ করেনি।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">২৯.</div>
            <div>Declared bank TDS is not found in declared income/ Bank TDS claimed more than declared income এ ধরনের
              সমস্যার ক্ষেত্রে করণীয় কি?
            </div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 20px"></div>
            <div>উত্তরঃ আপনি <strong>Income section</strong> ও <strong>Tax and payment</strong> এর Update tax payment এ
              ভিন্ন তথ্য ইনপুট দিয়েছেন। উভয় সেকশনে প্রকৃত তথ্য একইভাবে ইনপুট দিলে এই সমস্যা থাকবে না। অথবা সহজে ইনপুট
              দেবার জন্য আপনি e-Return Ledger এ Bank TDS এর ক্ষেত্রে Sync from Income ক্লিক করলে পূর্বে এন্ট্রিকৃত তথ্য
              দেখাবে যা সিলেক্ট করে সহজেই তথ্য হালনাগাদ করা যাবে এবং এই সমস্যা হবে না।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৩০.</div>
            <div>কর সেবা মাসে কি <strong>e-Return</strong> সংক্রান্ত সহায়তা পাওয়া যাবে?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px"></div>
            <div>উত্তরঃ বিভিন্ন কর অঞ্চল কর সেবা মাসে <strong>e-Return</strong> সংক্রান্ত সহায়তা প্রদান করছে।</div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৩১.</div>
            <div>গাড়ির কর সমন্বয় হচ্ছে না। করণীয় কি?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 20px"></div>
            <div>উত্তরঃ আপনি গাড়ির জন্য {{ currentIncomeYearArray[0] | convertNumWithOtherCharsToBn }}
              হতে {{ currentIncomeYearArray[1] | convertNumWithOtherCharsToBn }} এই সময়ের মধ্যে পরিশোধিত করের ব্যাংক
              স্লিপে উল্লিখিত ট্রানজেকশন আইডি ব্যবহার করলে সমন্বয়
              হবে। {{ currentIncomeYearArray[0] | convertNumWithOtherCharsToBn }} এর পূর্বে
              বা {{ currentIncomeYearArray[1] | convertNumWithOtherCharsToBn }} এর পরে পরিশোধিত কর এই বছরে দাখিলকৃত
              রিটার্নে সমন্বয় হবে না। এক্ষেত্রে কোন সমস্যার সম্মুখীন হলে কল সেন্টারের সহায়তা গ্রহণ করুন।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৩২.</div>
            <div>গত বছরে আমি ২টি প্রতিষ্ঠানে কর্মরত ছিলাম। ২টি চাকরির আয় কিভাবে প্রদর্শন করব?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px;"></div>
            <div>উত্তরঃ Employment income section এ Add Employment হতে আপনি একাধিক চাকরির তথ্য ও আয় ইনপুট দিতে পারবেন।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৩৩.</div>
            <div>আমার সম্পদ ৪ কোটির কম এবং ৮০০০ ব.ফু এর বাড়ি নেই। আমার একটি মোটরসাইকেল ও একটি মোটর কার রয়েছে। আমার জন্য
              কি সারচার্জ প্রযোজ্য?
            </div>
          </div>
          <div style="display:flex">
            <div style="width:40px;"></div>
            <div>উত্তরঃ না, প্রযোজ্য নয়।</div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৩৪.</div>
            <div>সঞ্চয়পত্রের আয় কিভাবে প্রদর্শন করব?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 20px"></div>
            <div>উত্তরঃ <strong>Income from Financial Assets</strong> পেজে সঞ্চয়পত্র Option এ <strong>Import from
              NSD</strong> বাটনে ক্লিক করলে আপনার সকল অনলাইন সঞ্চয়পত্রের তথ্য প্রদর্শন করবে আপনাকে কোন ইনপুট দিতে হবে
              না। এরপর সিলেক্ট করে Import করলে তথ্য সন্নিবেশিত হবে। তবে ৩০-০৬-২০১৯ তারিখের পূর্বের সঞ্চয়পত্রের ক্ষেত্রে
              আপনাকে তথ্য ইনপুট করতে হবে। <strong>Income from Financial Assets</strong> পেজে আয়ের সঠিকভাবে তথ্য ইনপুট
              দেবার পর <strong>e-Return Ledger</strong> এ সঞ্চয়পত্রের জন্য Sync from Income ক্লিক করলে উৎসে করের তথ্য
              আপডেট হবে।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৩৫.</div>
            <div>স্বর্ণ ও অন্যান্য সম্পদের কি বাজার মূল্য প্রদর্শন করব?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px;"></div>
            <div>উত্তরঃ না, পূর্ববর্তী বছরে প্রদর্শিত মূল্য, তবে নতুন হলে প্রকৃত ক্রয় মূল্য প্রদর্শন করতে হবে।</div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৩৬.</div>
            <div>আমি জাতীয় পরিচয়পত্রে নাম/জন্ম তারিখ সংশোধন করেছি। কিন্তু <strong>e-Return</strong> পূর্বের তথ্য
              প্রদর্শন করছে। এক্ষেত্রে করণীয় কি?
            </div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 10px"></div>
            <div>উত্তরঃ টিআইএন সিস্টেমে Revalidate অপশন হতে এটি পরিবর্তন করে <strong>e-Return</strong> সিস্টেমে Profile
              হতে Sync with TIN ব্যবহার করে আপডেট করতে পারবেন। প্রয়োজনে কল সেন্টারের সহায়তা গ্রহণ করুন।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৩৭.</div>
            <div>চিকিৎসক/আইনজীবী হিসেবে <strong>e-Return</strong> এ কোথায় আয় প্রদর্শন করব?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 20px"></div>
            <div>উত্তরঃ ব্যবসা বা পেশা হতে আয় হিসেবে প্রদর্শিত হবে। নিয়মিত আয়ের ক্ষেত্রে <strong>Regular Business
              Income</strong> এ আয়ের তথ্য পূরণ করতে হবে। যদি প্রাপ্তি/আয় হতে উৎসে কর কর্তন করা থাকে তবে
              Business/professional Income with TDS >> Profession/ Consultancy/ Other Services এ আয়ের তথ্য পূরণ করতে
              হবে।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৩৮.</div>
            <div>বিগত বছরের সকল সম্পদ কি এ বছর প্রদর্শন করতে হবে?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px;"></div>
            <div>উত্তরঃ বিগত বছরের যেসকল সম্পদ নগদায়ন বা হস্তান্তর হয়ে গেছে সেগুলো বাদে অবশিষ্ট সকল সম্পদ এ বছর প্রদর্শন
              করতে হবে।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৩৯.</div>
            <div>e-Return এ আমি কর পরিশোধ করেছি, আমার একাউন্ট/বিকাশ হতে টাকা কেটে নিয়েছে। কিন্তু এখনও আয়কর অপরিশোধিত
              রয়েছে। কিভাবে রিটার্ন দাখিল করব?
            </div>
          </div>
          <div style="display:flex">
            <div style="width:40px"></div>
            <div>উত্তরঃ আপনি সেভ করে লগ-আউট করে পুনরায় লগ-ইন করে <strong>Tax and payment</strong> পেজে যান, যদি এখনও
              অপরিশোধিত থাকে তবে কল সেন্টারের সহায়তা গ্রহণ করুন।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৪০.</div>
            <div>অনলাইনে দাখিলকৃত রিটার্নে ভুল হয়ে থাকলে কিভাবে তা সংশোধন করব?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px;"></div>
            <div>উত্তরঃ অনলাইনে দাখিলকৃত রিটার্নে ভুল হয়ে থাকলে দাখিলের ১৮০ দিনের মধ্যে আপনাকে অনলাইনে সংশোধিত রিটার্ন
              দাখিল করতে হবে। তবে সংশোধিত রিটার্ন একবার দাখিল করা যাবে।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৪১.</div>
            <div>আমি ৮ মাস ঢাকা উত্তর সিটি কর্পোরেশন ও ৪ মাস সাতক্ষীরায় চাকরি করেছি। আমি লোকেশনে কোন অপশন সিলেক্ট
              করব?
            </div>
          </div>
          <div style="display:flex">
            <div style="width:40px;"></div>
            <div>উত্তরঃ আপনি ঢাকা উত্তর সিটি কর্পোরেশন সিলেক্ট করবেন।</div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৪২.</div>
            <div>এমপিও’ভূক্ত শিক্ষক-কর্মচারীদের বেতন কি সরকারি না বেসরকারি চাকরিরত হিসেবে বিবেচিত হবে?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px;"></div>
            <div>উত্তরঃ বেসরকারি হিসেবে বিবেচিত হবেন।</div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৪৩.</div>
            <div>অনলাইনে রিটার্ন দাখিল করলে আমার তথ্য কি নিরাপদ থাকবে?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px;"></div>
            <div>উত্তরঃ আপনার তথ্য সম্পূর্ণ নিরাপদ থাকবে। জাতীয় রাজস্ব বোর্ড আইনগতভাবে তথ্যের গোপনীয়তা ও নিরাপত্তা
              নিশ্চিত করে।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৪৪.</div>
            <div>অনলাইনে রিটার্ন দাখিল করলে রিটার্নের সার্টিফাইড কপি কি পাওয়া যায়?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px;"></div>
            <div>উত্তরঃ হ্যাঁ, পাওয়া যাবে। ডিসিটি সার্টিফাইড কপি প্রদান করবেন।</div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৪৫.</div>
            <div>সময়ের পরে কি অনলাইন রিটার্ন দাখিল করা যাবে?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px;"></div>
            <div>উত্তরঃ হ্যাঁ, সময়ের পর সাধারণ পদ্ধতিতে অনলাইন রিটার্ন দাখিল করা যাবে।</div>
          </div>
        </div>

        <div class="mb-4">
          <div style="display:flex" class="mb-3 font-weight-bold">
            <div style="width: 40px">৪৬.</div>
            <div>এই বছরে eReturn এ কি কি নতুন অপশন পাওয়া যাবে?</div>
          </div>
          <div style="display:flex">
            <div style="width:40px; margin-right: 10px"></div>
            <div>উত্তরঃ এই বছরে eReturn এ নিম্নোক্ত নতুন অপশন পাওয়া যাবেঃ
              <br/>i) এই বছরে সঞ্চয়পত্রের আয়ের তথ্য পূরণের জন্য সঞ্চয়পত্রের সার্টিফিকেট প্রয়োজন হবে না। কারণ সঞ্চয়পত্রের
              আয়ের অপশনে <strong>Import From NSD</strong> বাটনে ক্লিক করে আপডেটেড তথ্য দেখা ও রিটার্নের সাথে যুক্ত করা
              যাবে। শুধুমাত্র ০১ লা জুলাই ২০১৯ এর পূর্বের কোনো সঞ্চয়পত্র থাকলে তা ম্যানুয়ালি এন্ট্রি দিতে হবে।
              <br/>ii) ইম্পোর্টের ক্ষেত্রে ১২০ ধারায় কর্তিত বা সংগৃহীত করের তথ্যও <strong>Claim</strong> বাটনে ক্লিক করে
              সয়ংক্রিয়ভাবে রিটার্নের সাথে যুক্ত করা যাবে।
              <br/>iii) ৩০ জুন ২০২৭ তারিখ পর্যন্ত স্বাভাবিক ব্যাক্তি করদাতা কর্তৃক স্বনির্ধারণী পদ্ধতিতে রিটার্ন দাখিল
              করা যাবে। তবে প্রদেয় করের ভিন্নতা থাকতে পারে-
              <br/>ক) ১ জুলাই হতে ৩০ সেপ্টেম্বর পর্যন্তঃ নীট প্রদেয় করের ৫% (সর্বোচ্চ ২৫,০০০) কর প্রণোদনা পাবেন।
              <br/>খ) ১ অক্টোবর হতে ৩১ ডিসেম্বর পর্যন্তঃ কোনো কর প্রণোদনা বা অতিরিক্ত কর প্রযোজ্য হবে না।
              <br/>গ) ১ জানুয়ারি হতে ৩১ মার্চ পর্যন্তঃ নীট প্রদেয় করের ২% (সর্বনিম্ন ৩,০০০) অতিরিক্ত কর প্রদেয় হবে।
              <br/>ঘ) ১ এপ্রিল হতে ৩০ জুন পর্যন্তঃ নীট প্রদেয় করের ৫% (সর্বনিম্ন ৫,০০০) অতিরিক্ত কর প্রদেয় হবে।
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-12">
      <button type="button" class="btn btn-sm backBtn mb-3" (click)="onBacktoMainPage()">
        <svg style="font-size: 20px;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-arrow-left"
             fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd"
                d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
        </svg>&nbsp;
        Back &nbsp;&nbsp;&nbsp;
      </button>
    </div>
  </div>
</div>
